<div class="edi-document-detail" *ngIf="orderResponseData">
  <lib-gung-tabset #ngbTab="gungTabset" orientation="vertical" [collapsible]="true">
    <header libGungTabsetHeader class="document-page-header">
      <div class="document-identity">
        <span class="document-type">
          <span translate>ORDER_RESPONSE</span>
        </span>
        <h3>{{ orderResponseData.id }}</h3>
        <p *ngIf="orderResponseData.ediConfigId">{{ orderResponseData.ediConfigId }}</p>
      </div>
      <div class="document-page-actions">
        <lib-edi-navigation-buttons [baseRoute]="ediNavigationBaseRoute"></lib-edi-navigation-buttons>
        <lib-edi-send-status class="edi-status-badge" [message]="orderResponseData"></lib-edi-send-status>
        <lib-action-btn [(item)]="orderResponseData" [config]="actionConfig"></lib-action-btn>
      </div>
    </header>
    <lib-gung-tab section="Document" icon="fa-solid fa-clipboard-check" title="Gung internal representation">
      <ng-template libGungTabContent>
        <div class="document-sheet">
          <section class="document-section document-overview">
            <header class="section-heading">
              <div>
                <h4>References and dates</h4>
              </div>
            </header>

            <div class="overview-layout">
              <section class="reference-panel" aria-label="Order response references">
                <div class="reference-groups">
                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Document references</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field document-field-primary">
                        <label for="orderResponseMessageId">Message ID</label>
                        <input class="form-control" id="orderResponseMessageId" type="text" [ngModel]="orderResponseData.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.documentReferences.orderResponse?.id">
                        <label for="orderResponseNumber" translate>ORDER_RESPONSE_NUMBER</label>
                        <input class="form-control" id="orderResponseNumber" type="text" [ngModel]="orderResponseData.documentReferences.orderResponse.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.documentReferences.orderResponse?.externalId">
                        <label for="orderResponseExternalId">Response external ID</label>
                        <input class="form-control" id="orderResponseExternalId" type="text" [ngModel]="orderResponseData.documentReferences.orderResponse.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="supplierOrderNumber" translate>SUPPLIER_ORDER_NUMBER</label>
                        <input class="form-control" id="supplierOrderNumber" type="text" [ngModel]="orderResponseData.documentReferences.supplierOrder.id" (ngModelChange)="orderResponseData.documentReferences.supplierOrder.id = $event" [disabled]="configService.disable.customerNumber" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.documentReferences.supplierOrder.externalId">
                        <label for="responseSupplierOrderExternalId">Supplier order external ID</label>
                        <input class="form-control" id="responseSupplierOrderExternalId" type="text" [ngModel]="orderResponseData.documentReferences.supplierOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="buyerOrderNumber" translate>BUYER_ORDER_NUMBER</label>
                        <input class="form-control" id="buyerOrderNumber" type="text" [ngModel]="orderResponseData.documentReferences.buyerOrder.id" (ngModelChange)="orderResponseData.documentReferences.buyerOrder.id = $event" [disabled]="configService.disable.supplierOrderNumber" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.documentReferences.buyerOrder.externalId">
                        <label for="responseBuyerOrderExternalId">Buyer order external ID</label>
                        <input class="form-control" id="responseBuyerOrderExternalId" type="text" [ngModel]="orderResponseData.documentReferences.buyerOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.orderMessageId">
                        <label for="responseSourceMessage">Source order message</label>
                        <input class="form-control" id="responseSourceMessage" type="text" [ngModel]="orderResponseData.orderMessageId" [disabled]="true" />
                      </div>
                      <div class="document-field document-field-wide" *ngIf="orderResponseData.erpIds?.length">
                        <label for="responseErpIds">ERP IDs</label>
                        <input class="form-control" id="responseErpIds" type="text" [ngModel]="orderResponseData.erpIds.join(', ')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Timeline</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field" *ngIf="orderResponseData.documentReferences.orderResponse?.date">
                        <label for="responseDate">Response date</label>
                        <input class="form-control" id="responseDate" type="text" [ngModel]="orderResponseData.documentReferences.orderResponse.date" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="orderDate" translate>ORDER_DATE</label>
                        <input class="form-control" id="orderDate" type="text" [ngModel]="orderResponseData.documentReferences.supplierOrder.date" (ngModelChange)="orderResponseData.documentReferences.supplierOrder.date = $event" [disabled]="configService.disable.orderDate" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.documentReferences.buyerOrder.date">
                        <label for="responseBuyerOrderDate" translate>BUYER_ORDER_DATE</label>
                        <input class="form-control" id="responseBuyerOrderDate" type="text" [ngModel]="orderResponseData.documentReferences.buyerOrder.date" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.shipmentDate">
                        <label for="responseShipmentDate">Shipment date</label>
                        <input class="form-control" id="responseShipmentDate" type="text" [ngModel]="orderResponseData.shipmentDate" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.deliveryDate">
                        <label for="deliveryDate" translate>DELIVERY_DATE</label>
                        <input class="form-control" id="deliveryDate" type="text" [(ngModel)]="orderResponseData.deliveryDate" [disabled]="configService.disable.deliveryDate" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.timestamp">
                        <label for="timestamp" translate>TIMESTAMP</label>
                        <input class="form-control" id="timestamp" type="text" [ngModel]="orderResponseData.timestamp" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.sentTimestamp">
                        <label for="deliveredTimestamp" translate>DELIVERED_TIMESTAMP</label>
                        <input class="form-control" id="deliveredTimestamp" type="text" [ngModel]="orderResponseData.sentTimestamp | date : (dateUtilService.dateFormat + ' HH:mm')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Processing</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="orderStatus" translate>GUNG_EDI_MESSAGE_SEND_STATUS</label>
                        <input class="form-control" id="orderStatus" type="text" [(ngModel)]="orderResponseData.gungEdiMessageSendStatus" [disabled]="configService.disable.orderStatus" />
                      </div>
                      <div class="document-field">
                        <label for="orderType" translate>ORDER_TYPE</label>
                        <input class="form-control" id="orderType" type="text" [(ngModel)]="orderResponseData.orderType" [disabled]="configService.disable.orderType" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.currency">
                        <label for="responseCurrency" translate>CURRENCY</label>
                        <input class="form-control" id="responseCurrency" type="text" [ngModel]="orderResponseData.currency" [disabled]="configService.disable.currency" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.deliveryTermId">
                        <label for="responseDeliveryTerm">Delivery term</label>
                        <input class="form-control" id="responseDeliveryTerm" type="text" [ngModel]="orderResponseData.deliveryTermId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderResponseData.paymentTermText">
                        <label for="responsePaymentTerm">Payment terms</label>
                        <input class="form-control" id="responsePaymentTerm" type="text" [ngModel]="orderResponseData.paymentTermText" [disabled]="true" />
                      </div>
                    </div>
                  </section>
                </div>
              </section>

              <section class="party-panel" aria-label="Order response parties">
                <div class="panel-heading">
                  <div>
                    <span>Order parties</span>
                  </div>
                </div>
                <lib-edi-gln-number-tabs
                  [ediMessage]="orderResponseData"
                  [documentStyle]="true"
                ></lib-edi-gln-number-tabs>
              </section>
            </div>
          </section>

          <lib-edi-detail-error-display [ediMessage]="orderResponseData"></lib-edi-detail-error-display>

          <section class="document-section document-lines">
            <header class="section-heading lines-heading">
              <div>
                <h4><span translate>ORDER_LINES</span></h4>
              </div>
              <span class="line-count">{{ itemCount }} lines · {{ changedLineCount }} changed</span>
            </header>
            <lib-edi-row-table
              [data]="orderResponseData.items"
              [columns]="itemsColumns"
              customClass="document-items-table"
            ></lib-edi-row-table>
          </section>

          <section class="document-section document-summary" *ngIf="itemCount || hasDeliveryWindow">
            <header class="section-heading">
              <div>
                <h4>Confirmation summary</h4>
              </div>
            </header>

            <div class="status-summary-grid" *ngIf="itemCount">
              <div class="status-summary-card status-summary-card-positive">
                <strong>{{ responseSummary.acceptedLineCount }}</strong>
                <span>Accepted</span>
              </div>
              <div class="status-summary-card status-summary-card-warning">
                <strong>{{ responseSummary.changedLineCount }}</strong>
                <span>Changed</span>
              </div>
              <div class="status-summary-card status-summary-card-negative">
                <strong>{{ responseSummary.rejectedLineCount }}</strong>
                <span>Rejected</span>
              </div>
              <div class="status-summary-card status-summary-card-neutral">
                <strong>{{ responseSummary.unconfirmedLineCount }}</strong>
                <span>Unconfirmed</span>
              </div>
            </div>

            <div class="summary-grid">
              <div class="summary-value-card" *ngFor="let quantity of responseSummary.orderedQuantities">
                <span>Ordered quantity</span>
                <strong>{{ formatNumber(quantity.value) }}<small *ngIf="quantity.unit"> {{ quantity.unit }}</small></strong>
              </div>
              <div class="summary-value-card" *ngFor="let quantity of responseSummary.confirmedQuantities">
                <span>Confirmed quantity</span>
                <strong>{{ formatNumber(quantity.value) }}<small *ngIf="quantity.unit"> {{ quantity.unit }}</small></strong>
              </div>
              <div class="summary-value-card" *ngFor="let amount of responseSummary.confirmedAmounts">
                <span>Confirmed net value</span>
                <strong>{{ formatAmount(amount) }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="hasDeliveryWindow">
                <span>Confirmed delivery</span>
                <strong>
                  {{ responseSummary.earliestDeliveryDate | date : dateUtilService.dateFormat }}
                  <ng-container *ngIf="hasDeliveryDateRange">
                    – {{ responseSummary.latestDeliveryDate | date : dateUtilService.dateFormat }}
                  </ng-container>
                </strong>
              </div>
            </div>
          </section>
        </div>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab
      section="Related EDI messages"
      icon="fa-solid fa-cart-arrow-down"
      title="Source EDI order"
      *ngIf="orderResponseData.orderMessageId"
      [link]="['/admin/edi/orders', orderResponseData.orderMessageId]"
    ></lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-reply" [title]="'ORDER_RESPONSES' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="ordrsp"
          [relations]="relations"
          [ediConfigId]="orderResponseData.ediConfigId"
          [currentMessageId]="orderResponseData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-truck" [title]="'RELATED_EDI_DESADV' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="desadv"
          [relations]="relations"
          [ediConfigId]="orderResponseData.ediConfigId"
          [currentMessageId]="orderResponseData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-file-invoice" [title]="'RELATED_EDI_INVOIC' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="invoice"
          [relations]="relations"
          [ediConfigId]="orderResponseData.ediConfigId"
          [currentMessageId]="orderResponseData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab
      *ngFor="let erpOrderId of erpOrderIds"
      section="ERP orders"
      icon="fa-solid fa-boxes-stacked"
      [title]="erpOrderId"
      [link]="['/orders', erpOrderId]"
    ></lib-gung-tab>
    <lib-gung-tab section="External EDI"
      icon="fa-solid fa-file-lines"
      title="External EDI representation"
      *ngIf="orderResponseData.fileNameInclPath && (documentViewerEnabled$ | async)"
    >
      <ng-template libGungTabContent>
        <div class="pt-4">
          <lib-edi-document-viewer
            [messageId]="orderResponseData.id"
            messageType="ORDER_RESPONSE"
            [useAi]="true"
          ></lib-edi-document-viewer>
        </div>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</div>
